import styled from "styled-components";

export const Container = styled.div`
  padding: 5px;
  width: 100px;
  height: 100px;
`;

export const Image = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
`;
